
import React from "react";
import UploadSection from "./UploadSection";

function App() {
  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <UploadSection />
    </div>
  );
}

export default App;
